import { cn } from '@/lib/utils'

/**
 * Loading placeholder using the MES shimmer keyframe (theme.css).
 * Defaults to a 1.4s gradient sweep across `bg-card → bg-secondary → bg-card`
 * — replaces the previous shadcn `animate-pulse bg-accent` which flashed
 * lime after the dark-token migration.
 */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" className={cn('skeleton-shimmer', className)} {...props} />
}

export { Skeleton }
